export enum ProjectsFolder {
  Personal = 'Personal',
  Shared = 'Shared',
}

export enum ItemsFolder {
  Public = 'Public',
  Personal = 'Personal',
  Shared = 'Shared',
  Intel = 'StackDX Intel',
  Stack = 'StackDX Land',
  ArcGIS = 'ArcGIS',
}

export const libraryFolders = {
  projects: Object.values(ProjectsFolder),
  items: Object.values(ItemsFolder),
};

export type LibrarySection = keyof typeof libraryFolders;
export type LibraryFolder = ProjectsFolder | ItemsFolder;
